import type { FormRenderProps } from "react-final-form-hooks";

export default function checkCanSubmit<S>({
  pristine,
  submitFailed,
  submitting,
  hasValidationErrors,
  touched,
}: Partial<FormRenderProps<S>>) {
  if (submitting) {
    return false;
  }

  if (pristine) {
    const anyTouched = touched ? Object.values(touched).some(Boolean) : false;

    if (anyTouched) {
      return !hasValidationErrors;
    }

    return !submitFailed;
  }

  return !hasValidationErrors;
}
